import { shareDecision } from "api";
import { Error } from "utils/Response";
import { ActionTypes } from "./types";

export const ShareDecision = (payload, setIsSuccessful) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await shareDecision(payload);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
      dispatch(setIsSuccessful(true));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
